import { render } from "./AddAnnouncement.vue?vue&type=template&id=bbc3fee8&scoped=true"
import script from "./AddAnnouncement.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddAnnouncement.vue?vue&type=script&charset=utf-8&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AddAnnouncement.vue?vue&type=style&index=1&id=bbc3fee8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc3fee8"]])

export default __exports__